import type { ICommonObject } from '../common';

export enum VaultType {
    BANK = 'BANK',
    PRIVATE = 'PRIVATE',
}

export interface IVault {
    commonObject: ICommonObject;
    name: string;
    type: VaultType;
}

export interface IFetchVaultsRequest {
    'external-id'?: string[];
    page?: number; // default value: 50
    'page-size'?: number;
    sort?: string; // attribute to sort by and optionally a sort order (e.g. values "author", “author,desc”)
}
